import { graphql as apolloGraphql, } from 'react-apollo';
import { withMutation } from './with-mutation';
import { isMutationType } from '../utils';
export function graphql(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    if (isMutationType(document)) {
        return withMutation(document, operationOptions);
    }
    return apolloGraphql(document, operationOptions);
}
//# sourceMappingURL=graphql.js.map